import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLuckyForLife = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 250 250"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <defs>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient"
          cx={121.53}
          cy={-987.73}
          r={125.05}
          fx={121.53}
          fy={-987.73}
          gradientTransform="rotate(1.2 -53037.025 -199.027)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.8} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-2"
          cx={121.53}
          cy={-987.73}
          r={125.05}
          fx={121.53}
          fy={-987.73}
          gradientTransform="rotate(1.2 -53037.025 -199.027)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.8} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.7} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-3"
          cx={1467.73}
          cy={1561.8}
          r={9.07}
          fx={1467.73}
          fy={1561.8}
          gradientTransform="rotate(56.1 2189.7 -332.074)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-4"
          cx={1467.12}
          cy={1562.21}
          r={6.23}
          fx={1467.12}
          fy={1562.21}
          gradientTransform="rotate(56.1 2189.95 -329.798)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-5"
          cx={1467.73}
          cy={1561.8}
          r={9.07}
          fx={1467.73}
          fy={1561.8}
          gradientTransform="rotate(56.1 2189.7 -332.074)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-6"
          cx={1467.12}
          cy={1562.21}
          r={6.23}
          fx={1467.12}
          fy={1562.21}
          gradientTransform="rotate(56.1 2189.95 -329.798)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-7"
          cx={924.57}
          cy={948.13}
          r={9.01}
          fx={924.57}
          fy={948.13}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-8"
          cx={1368.89}
          cy={1708.92}
          r={6.23}
          fx={1368.89}
          fy={1708.92}
          gradientTransform="rotate(56.1 2189.75 -331.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-9"
          cx={924.57}
          cy={948.13}
          r={9.01}
          fx={924.57}
          fy={948.13}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-10"
          cx={1368.89}
          cy={1708.92}
          r={6.23}
          fx={1368.89}
          fy={1708.92}
          gradientTransform="rotate(56.1 2189.75 -331.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-11"
          cx={1047.81}
          cy={925.28}
          r={9.01}
          fx={1047.81}
          fy={925.28}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-12"
          cx={1491.05}
          cy={1685.32}
          r={6.23}
          fx={1491.05}
          fy={1685.32}
          gradientTransform="rotate(56.1 2189.712 -329.791)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-13"
          cx={1047.81}
          cy={925.28}
          r={9.01}
          fx={1047.81}
          fy={925.28}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-14"
          cx={1491.05}
          cy={1685.32}
          r={6.23}
          fx={1491.05}
          fy={1685.32}
          gradientTransform="rotate(56.1 2189.712 -329.791)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-15"
          cx={898.61}
          cy={822.3}
          r={9.01}
          fx={898.61}
          fy={822.3}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-16"
          cx={1344.59}
          cy={1586.21}
          r={6.22}
          fx={1344.59}
          fy={1586.21}
          gradientTransform="rotate(56.1 2189.75 -331.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-17"
          cx={898.61}
          cy={822.3}
          r={9.01}
          fx={898.61}
          fy={822.3}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-18"
          cx={1344.59}
          cy={1586.21}
          r={6.22}
          fx={1344.59}
          fy={1586.21}
          gradientTransform="rotate(56.1 2189.75 -331.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-19"
          cx={1046.42}
          cy={864.35}
          r={9.01}
          fx={1046.42}
          fy={864.35}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-20"
          cx={1486.64}
          cy={1617.33}
          r={6.22}
          fx={1486.64}
          fy={1617.33}
          gradientTransform="rotate(56.1 2189.75 -331.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-21"
          cx={1046.42}
          cy={864.35}
          r={9.01}
          fx={1046.42}
          fy={864.35}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-22"
          cx={1486.64}
          cy={1617.33}
          r={6.22}
          fx={1486.64}
          fy={1617.33}
          gradientTransform="rotate(56.1 2189.75 -331.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-23"
          cx={1037.02}
          cy={829.78}
          r={9.01}
          fx={1037.02}
          fy={829.78}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-24"
          cx={1480.83}
          cy={1591.02}
          r={6.23}
          fx={1480.83}
          fy={1591.02}
          gradientTransform="rotate(56.1 2189.95 -329.798)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-25"
          cx={1037.02}
          cy={829.78}
          r={9.01}
          fx={1037.02}
          fy={829.78}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-26"
          cx={1480.83}
          cy={1591.02}
          r={6.23}
          fx={1480.83}
          fy={1591.02}
          gradientTransform="rotate(56.1 2189.95 -329.798)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-27"
          cx={1049.67}
          cy={892.43}
          r={9.01}
          fx={1049.67}
          fy={892.43}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-28"
          cx={1493.09}
          cy={1653.1}
          r={6.23}
          fx={1493.09}
          fy={1653.1}
          gradientTransform="rotate(56.1 2189.762 -329.698)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-29"
          cx={1049.67}
          cy={892.43}
          r={9.01}
          fx={1049.67}
          fy={892.43}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-30"
          cx={1493.09}
          cy={1653.1}
          r={6.23}
          fx={1493.09}
          fy={1653.1}
          gradientTransform="rotate(56.1 2189.762 -329.698)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-31"
          cx={903.25}
          cy={885.68}
          r={9.01}
          fx={903.25}
          fy={885.68}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-32"
          cx={1349.22}
          cy={1649.51}
          r={6.23}
          fx={1349.22}
          fy={1649.51}
          gradientTransform="rotate(56.1 2189.75 -331.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-33"
          cx={903.25}
          cy={885.68}
          r={9.01}
          fx={903.25}
          fy={885.68}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-34"
          cx={1349.22}
          cy={1649.51}
          r={6.23}
          fx={1349.22}
          fy={1649.51}
          gradientTransform="rotate(56.1 2189.75 -331.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-35"
          cx={908.08}
          cy={918.86}
          r={9.01}
          fx={908.08}
          fy={918.86}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-36"
          cx={1353}
          cy={1680.78}
          r={6.22}
          fx={1353}
          fy={1680.78}
          gradientTransform="rotate(56.1 2189.75 -331.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-37"
          cx={908.08}
          cy={918.86}
          r={9.01}
          fx={908.08}
          fy={918.86}
          gradientTransform="matrix(1 0 0 -1 0 -447.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-38"
          cx={1353}
          cy={1680.78}
          r={6.22}
          fx={1353}
          fy={1680.78}
          gradientTransform="rotate(56.1 2189.75 -331.98)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-39"
          cx={3738.23}
          cy={-8242.91}
          r={9.01}
          fx={3738.23}
          fy={-8242.91}
          gradientTransform="rotate(-33.9 15603.032 1758.982)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-40"
          cx={3740.41}
          cy={-8241.94}
          r={6.23}
          fx={3740.41}
          fy={-8241.94}
          gradientTransform="rotate(-33.9 15601.257 1771.1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-41"
          cx={3738.23}
          cy={-8242.91}
          r={9.01}
          fx={3738.23}
          fy={-8242.91}
          gradientTransform="rotate(-33.9 15603.032 1758.982)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-42"
          cx={3740.41}
          cy={-8241.94}
          r={6.23}
          fx={3740.41}
          fy={-8241.94}
          gradientTransform="rotate(-33.9 15601.257 1771.1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-43"
          cx={3746.24}
          cy={-8212.05}
          r={9.01}
          fx={3746.24}
          fy={-8212.05}
          gradientTransform="rotate(-33.9 15603.032 1758.982)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-44"
          cx={3748.47}
          cy={-8211.07}
          r={6.23}
          fx={3748.47}
          fy={-8211.07}
          gradientTransform="rotate(-33.9 15601.614 1771.28)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-45"
          cx={3746.24}
          cy={-8212.05}
          r={9.01}
          fx={3746.24}
          fy={-8212.05}
          gradientTransform="rotate(-33.9 15603.032 1758.982)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-46"
          cx={3748.47}
          cy={-8211.07}
          r={6.23}
          fx={3748.47}
          fy={-8211.07}
          gradientTransform="rotate(-33.9 15601.614 1771.28)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-47"
          cx={3597.56}
          cy={-8215.36}
          r={9.01}
          fx={3597.56}
          fy={-8215.36}
          gradientTransform="rotate(-33.9 15603.032 1758.982)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-48"
          cx={3599.82}
          cy={-8214.41}
          r={6.23}
          fx={3599.82}
          fy={-8214.41}
          gradientTransform="rotate(-33.9 15601.779 1771.33)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-49"
          cx={3597.56}
          cy={-8215.36}
          r={9.01}
          fx={3597.56}
          fy={-8215.36}
          gradientTransform="rotate(-33.9 15603.032 1758.982)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-50"
          cx={3599.82}
          cy={-8214.41}
          r={6.23}
          fx={3599.82}
          fy={-8214.41}
          gradientTransform="rotate(-33.9 15601.779 1771.33)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-51"
          cx={3593.85}
          cy={-8246.62}
          r={9.01}
          fx={3593.85}
          fy={-8246.62}
          gradientTransform="rotate(-33.9 15603.032 1758.982)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-52"
          cx={3593.99}
          cy={-8246.57}
          r={6.22}
          fx={3593.99}
          fy={-8246.57}
          gradientTransform="rotate(-33.9 15602.996 1759.688)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-53"
          cx={3593.85}
          cy={-8246.62}
          r={9.01}
          fx={3593.85}
          fy={-8246.62}
          gradientTransform="rotate(-33.9 15603.032 1758.982)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-54"
          cx={3593.99}
          cy={-8246.57}
          r={6.22}
          fx={3593.99}
          fy={-8246.57}
          gradientTransform="rotate(-33.9 15602.996 1759.688)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-55"
          cx={3605.91}
          cy={-8185.03}
          r={9.01}
          fx={3605.91}
          fy={-8185.03}
          gradientTransform="rotate(-33.9 15603.032 1758.982)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-56"
          cx={3608.13}
          cy={-8184.1}
          r={6.23}
          fx={3608.13}
          fy={-8184.1}
          gradientTransform="rotate(-33.9 15601.829 1771.166)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-57"
          cx={3605.91}
          cy={-8185.03}
          r={9.01}
          fx={3605.91}
          fy={-8185.03}
          gradientTransform="rotate(-33.9 15603.032 1758.982)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.7} />
          <stop offset={0.4} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.3} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="lucky-for-life_svg__radial-gradient-58"
          cx={3608.13}
          cy={-8184.1}
          r={6.23}
          fx={3608.13}
          fy={-8184.1}
          gradientTransform="rotate(-33.9 15601.829 1771.166)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.3} stopColor="#fff" stopOpacity={0.6} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.8} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <style>
          {
            ".lucky-for-life_svg__cls-1{fill:#00c6a6}.lucky-for-life_svg__cls-11{fill:#002812}.lucky-for-life_svg__cls-62{fill:#fff}.lucky-for-life_svg__cls-65{fill:#fefdfe}"
          }
        </style>
      </defs>
      <g id="lucky-for-life_svg__Layer_1" data-name="Layer 1">
        <g id="lucky-for-life_svg__Shape">
          <circle
            cx={125.76}
            cy={125.7}
            r={125.03}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient)",
            }}
          />
          <circle
            cx={125.76}
            cy={125.7}
            r={125.03}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-2)",
            }}
          />
          <rect
            width={137.22}
            height={137.22}
            x={57.92}
            y={56.39}
            className="lucky-for-life_svg__cls-1"
            rx={23.44}
            ry={23.44}
            transform="rotate(-45 126.527 125)"
          />
          <path
            d="M126.49 208.54c-5.23 0-10.2-2.05-13.91-5.76l-63.91-63.91c-7.68-7.68-7.68-20.13 0-27.81l63.91-63.91c3.71-3.71 8.68-5.76 13.91-5.76s10.2 2.05 13.91 5.76l63.91 63.91c7.68 7.68 7.68 20.13 0 27.81l-63.91 63.91a19.6 19.6 0 0 1-13.91 5.76"
            style={{
              fill: "#f84353",
            }}
          />
          <circle
            cx={215.1}
            cy={124.97}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-3)",
            }}
          />
          <circle
            cx={215.3}
            cy={125.03}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-4)",
            }}
          />
          <path
            d="M213.18 122.05c-1.59 1.06-1.99 3.18-.99 4.77s3.18 2.05 4.77.99 1.99-3.18.99-4.77-3.18-2.05-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={215.1}
            cy={124.97}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-5)",
            }}
          />
          <circle
            cx={215.3}
            cy={125.03}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-6)",
            }}
          />
          <path
            d="M213.18 122.05c-1.59 1.06-1.99 3.18-.99 4.77s3.18 2.05 4.77.99 1.99-3.18.99-4.77-3.18-2.05-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={37.95}
            cy={124.97}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-7)",
            }}
          />
          <circle
            cx={37.95}
            cy={124.97}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-8)",
            }}
          />
          <path
            d="M36.03 122.05c-1.59 1.06-1.99 3.18-.99 4.77 1.06 1.59 3.18 2.05 4.77.99s1.99-3.18.99-4.77c-1.06-1.59-3.18-2.05-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={37.95}
            cy={124.97}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-9)",
            }}
          />
          <circle
            cx={37.95}
            cy={124.97}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-10)",
            }}
          />
          <path
            d="M36.03 122.05c-1.59 1.06-1.99 3.18-.99 4.77 1.06 1.59 3.18 2.05 4.77.99s1.99-3.18.99-4.77c-1.06-1.59-3.18-2.05-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={126.23}
            cy={213.51}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-11)",
            }}
          />
          <circle
            cx={126.23}
            cy={213.71}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-12)",
            }}
          />
          <path
            d="M124.3 210.66c-1.59 1.06-2.05 3.18-.99 4.77s3.18 1.99 4.77.99 2.05-3.18.99-4.77-3.18-1.99-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={126.23}
            cy={213.51}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-13)",
            }}
          />
          <circle
            cx={126.23}
            cy={213.71}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-14)",
            }}
          />
          <path
            d="M124.3 210.66c-1.59 1.06-2.05 3.18-.99 4.77s3.18 1.99 4.77.99 2.05-3.18.99-4.77-3.18-1.99-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={126.23}
            cy={36.36}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-15)",
            }}
          />
          <circle
            cx={126.23}
            cy={36.36}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-16)",
            }}
          />
          <path
            d="M124.3 33.51c-1.59 1.06-2.05 3.18-.99 4.77s3.18 1.99 4.77.99c1.59-1.06 2.05-3.18.99-4.77s-3.18-1.99-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={126.23}
            cy={36.36}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-17)",
            }}
          />
          <circle
            cx={126.23}
            cy={36.36}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-18)",
            }}
          />
          <path
            d="M124.3 33.51c-1.59 1.06-2.05 3.18-.99 4.77s3.18 1.99 4.77.99c1.59-1.06 2.05-3.18.99-4.77s-3.18-1.99-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={179.6}
            cy={171.59}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-19)",
            }}
          />
          <circle
            cx={179.6}
            cy={171.59}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-20)",
            }}
          />
          <path
            d="M177.75 168.74c-1.59 1.06-1.99 3.18-.99 4.77s3.18 1.99 4.77.99 1.99-3.18.99-4.77-3.18-1.99-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={179.6}
            cy={171.59}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-21)",
            }}
          />
          <circle
            cx={179.6}
            cy={171.59}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-22)",
            }}
          />
          <path
            d="M177.75 168.74c-1.59 1.06-1.99 3.18-.99 4.77s3.18 1.99 4.77.99 1.99-3.18.99-4.77-3.18-1.99-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={198.81}
            cy={152.38}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-23)",
            }}
          />
          <circle
            cx={198.94}
            cy={152.52}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-24)",
            }}
          />
          <path
            d="M196.95 149.54c-1.59 1.06-1.99 3.18-.99 4.77s3.18 2.05 4.77.99 1.99-3.18.99-4.77-3.18-2.05-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={198.81}
            cy={152.38}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-25)",
            }}
          />
          <circle
            cx={198.94}
            cy={152.52}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-26)",
            }}
          />
          <path
            d="M196.95 149.54c-1.59 1.06-1.99 3.18-.99 4.77s3.18 2.05 4.77.99 1.99-3.18.99-4.77-3.18-2.05-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={154.17}
            cy={197.22}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-27)",
            }}
          />
          <circle
            cx={154.24}
            cy={197.42}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-28)",
            }}
          />
          <path
            d="M152.25 194.37c-1.59 1.06-2.05 3.18-.99 4.77s3.18 1.99 4.77.99 2.05-3.18.99-4.77-3.18-1.99-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={154.17}
            cy={197.22}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-29)",
            }}
          />
          <circle
            cx={154.24}
            cy={197.42}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-30)",
            }}
          />
          <path
            d="M152.25 194.37c-1.59 1.06-2.05 3.18-.99 4.77s3.18 1.99 4.77.99 2.05-3.18.99-4.77-3.18-1.99-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={76.29}
            cy={75.5}
            r={9.07}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-31)",
            }}
          />
          <circle
            cx={76.23}
            cy={75.5}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-32)",
            }}
          />
          <path
            d="M74.37 72.65c-1.59 1.06-2.05 3.18-.99 4.77s3.18 2.05 4.77.99 2.05-3.18.99-4.77-3.18-2.05-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={76.29}
            cy={75.5}
            r={9.07}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-33)",
            }}
          />
          <circle
            cx={76.23}
            cy={75.5}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-34)",
            }}
          />
          <path
            d="M74.37 72.65c-1.59 1.06-2.05 3.18-.99 4.77s3.18 2.05 4.77.99 2.05-3.18.99-4.77-3.18-2.05-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={52.45}
            cy={96.03}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-35)",
            }}
          />
          <circle
            cx={52.38}
            cy={96.03}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-36)",
            }}
          />
          <path
            d="M50.53 93.18c-1.59 1.06-2.05 3.18-.99 4.77s3.18 2.05 4.77.99 2.05-3.18.99-4.77-3.18-2.05-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={52.45}
            cy={96.03}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-37)",
            }}
          />
          <circle
            cx={52.38}
            cy={96.03}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-38)",
            }}
          />
          <path
            d="M50.53 93.18c-1.59 1.06-2.05 3.18-.99 4.77s3.18 2.05 4.77.99 2.05-3.18.99-4.77-3.18-2.05-4.77-.99"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={176.29}
            cy={74.83}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-39)",
            }}
          />
          <circle
            cx={176.39}
            cy={74.85}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-40)",
            }}
          />
          <path
            d="M173.44 76.75c1.06 1.59 3.18 2.05 4.77.99s1.99-3.18.99-4.77-3.18-2.05-4.77-.99-1.99 3.18-.99 4.77"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={176.29}
            cy={74.83}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-41)",
            }}
          />
          <circle
            cx={176.39}
            cy={74.85}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-42)",
            }}
          />
          <path
            d="M173.44 76.75c1.06 1.59 3.18 2.05 4.77.99s1.99-3.18.99-4.77-3.18-2.05-4.77-.99-1.99 3.18-.99 4.77"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={200.13}
            cy={96.03}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-43)",
            }}
          />
          <circle
            cx={200.26}
            cy={96.16}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-44)",
            }}
          />
          <path
            d="M197.28 97.95c1.06 1.59 3.18 2.05 4.77.99s1.99-3.18.99-4.77-3.18-2.05-4.77-.99-1.99 3.18-.99 4.77"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={200.13}
            cy={96.03}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-45)",
            }}
          />
          <circle
            cx={200.26}
            cy={96.16}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-46)",
            }}
          />
          <path
            d="M197.28 97.95c1.06 1.59 3.18 2.05 4.77.99s1.99-3.18.99-4.77-3.18-2.05-4.77-.99-1.99 3.18-.99 4.77"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={74.97}
            cy={176.23}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-47)",
            }}
          />
          <circle
            cx={74.97}
            cy={176.36}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-48)",
            }}
          />
          <path
            d="M72.05 178.15c1.06 1.59 3.18 1.99 4.77.99s2.05-3.18.99-4.77-3.18-1.99-4.77-.99-2.05 3.18-.99 4.77"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={74.97}
            cy={176.23}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-49)",
            }}
          />
          <circle
            cx={74.97}
            cy={176.36}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-50)",
            }}
          />
          <path
            d="M72.05 178.15c1.06 1.59 3.18 1.99 4.77.99s2.05-3.18.99-4.77-3.18-1.99-4.77-.99-2.05 3.18-.99 4.77"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={54.44}
            cy={152.38}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-51)",
            }}
          />
          <circle
            cx={54.37}
            cy={152.38}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-52)",
            }}
          />
          <path
            d="M51.52 154.3c1.06 1.59 3.18 2.05 4.77.99s2.05-3.18.99-4.77-3.18-2.05-4.77-.99-2.05 3.18-.99 4.77"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={54.44}
            cy={152.38}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-53)",
            }}
          />
          <circle
            cx={54.37}
            cy={152.38}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-54)",
            }}
          />
          <path
            d="M51.52 154.3c1.06 1.59 3.18 2.05 4.77.99s2.05-3.18.99-4.77-3.18-2.05-4.77-.99-2.05 3.18-.99 4.77"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={98.74}
            cy={196.75}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-55)",
            }}
          />
          <circle
            cx={98.87}
            cy={196.95}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-56)",
            }}
          />
          <path
            d="M95.89 198.68c1.06 1.59 3.18 1.99 4.77.99s2.05-3.18.99-4.77-3.18-1.99-4.77-.99-2.05 3.18-.99 4.77"
            className="lucky-for-life_svg__cls-62"
          />
          <circle
            cx={98.74}
            cy={196.75}
            r={9.01}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-57)",
            }}
          />
          <circle
            cx={98.87}
            cy={196.95}
            r={6.23}
            style={{
              fill: "url(#lucky-for-life_svg__radial-gradient-58)",
            }}
          />
          <path
            d="M95.89 198.68c1.06 1.59 3.18 1.99 4.77.99s2.05-3.18.99-4.77-3.18-1.99-4.77-.99-2.05 3.18-.99 4.77"
            className="lucky-for-life_svg__cls-62"
          />
        </g>
        <g id="lucky-for-life_svg__Layer_11" data-name="Layer 11">
          <path
            d="m96.75 88.87 9.41 4.38"
            style={{
              fill: "none",
              stroke: "#001914",
              strokeMiterlimit: 10,
              strokeWidth: "1.39px",
            }}
          />
          <path
            d="M110.93 61.72s-30.33 19.4-31.72 43.77v9.01h11.13s-.53-15.96 10-30.66 18.01-24.11 18.01-24.11L111 61.65z"
            style={{
              fill: "#aa753e",
            }}
          />
          <path
            d="M90.26 115.7H78.14v-10.07c1.13-19.6 20.2-35.89 28.48-42.05l5.1-5.5 8.48.86-4.5 5.96a780 780 0 0 0-14.64 19.74c-10.2 14.24-9.8 29.87-9.8 30v1.06H90.2h.07Zm-10.06-2.06h9.01c.07-3.84.99-17.42 10.2-30.2 6.23-8.68 11.39-15.56 14.64-19.74l2.25-3.05-3.84-.4-4.57 4.9c-8.01 5.96-26.69 21.79-27.75 40.53v7.95h.07Z"
            className="lucky-for-life_svg__cls-11"
          />
          <path
            d="m100.608 70.35.96-1.812 7.079 3.748-.96 1.812zM93.785 76.895l1.04-1.766L103.097 80l-1.04 1.767zM87.086 85.198l.863-1.86 9.787 4.544-.863 1.86zM81.404 96.175l.239-2.036L93.75 95.56l-.24 2.036z"
            className="lucky-for-life_svg__cls-11"
          />
          <path
            d="M119.01 47.62s.99-26.23-28.28-18.01c0 0 13.05 4.7 18.28 16.23 0 0-15.63-10.13-27.28-.26 0 0-5.43 5.7-6.09 7.62 0 0 15.36-4.44 26.49 2.05 0 0-15.63 2.05-16.23 20.93 0 0 9.14-12.05 29.14-13.44 0 0 11.26 15.1 11.13 29.01 0 0 13.44-14.3 1.92-28.15 0 0 15.1 5.7 21.32 15.83 0 0 5.23-24.57-20.79-26.03 0 0 6.36-3.58 24.7-1.52 0 0-5.96-10.79-17.75-10.26s-16.49 6.09-16.49 6.09h-.07v-.07Z"
            className="lucky-for-life_svg__cls-1"
          />
          <path
            d="M124.97 94.44v-2.65c.13-10.6-6.62-21.99-9.54-26.42v-.13c-.33-.46-.73-1.26-1.06-1.66-.93 0-4.24.66-6.89 1.39-14.04 3.25-20.79 11.85-20.86 11.92l-1.92 2.52v-3.18c.53-14.57 9.74-19.6 14.44-21.19-10.33-4.44-23.18-.79-23.31-.79l-1.92.53.66-1.92c.73-2.05 5.43-7.02 6.36-8.01 5.03-4.3 11.59-5.63 18.94-3.84 2.58.6 4.83 1.52 6.49 2.32-5.7-8.87-15.96-12.65-16.09-12.72l-3.05-1.13 3.11-.86c9.74-2.72 17.28-1.99 22.45 2.05 5.5 4.3 6.75 11.19 7.09 14.7 2.38-1.79 7.28-4.5 15.5-4.9 12.32-.6 18.41 10.33 18.68 10.79l.93 1.72-1.99-.2c-9.54-1.06-15.83-.6-19.54 0 5.7 1.13 10.07 3.64 12.98 7.55 6.09 8.01 3.84 18.68 3.77 19.14l-.53 2.52-1.32-2.19c-4.24-6.82-12.78-11.66-17.48-13.91 7.88 13.38-4.04 26.29-4.17 26.42l-1.79 1.92v.13l.07.07Zm-7.75-30.14c2.78 4.24 8.81 14.5 9.74 24.7 1.06-1.52 2.45-3.77 3.44-6.49 2.38-6.62 1.32-12.78-3.18-18.21l-2.52-2.98 3.64 1.39c.6.2 13.38 5.1 20.33 13.97.26-3.51.07-9.93-3.71-14.9-3.38-4.44-8.87-6.89-16.42-7.35l-3.51-.2 3.05-1.72c.26-.13 6.36-3.44 23.11-1.85-2.19-2.91-7.48-8.34-15.63-7.95-11.13.53-15.7 5.7-15.76 5.76l-1.92 2.19v-2.91c.07-.13.4-10.07-6.29-15.3-4.11-3.25-10.07-4.04-17.68-2.45 4.24 2.12 12.19 6.95 16.03 15.5l1.46 3.18-2.98-1.92c-.13-.13-15.17-9.54-26.03-.4-1.39 1.46-3.31 3.64-4.57 5.3 4.9-.99 16.03-2.38 24.77 2.78l2.58 1.52-2.98.4c-.6 0-13.18 1.99-15.1 17.02 3.05-2.98 9.54-8.01 19.93-10.46 7.62-2.05 8.28-1.39 8.68-1.06.73.66 1.39 1.99 1.59 2.38l-.07.07Z"
            className="lucky-for-life_svg__cls-11"
          />
        </g>
      </g>
      <g id="lucky-for-life_svg__Isolation_Mode" data-name="Isolation Mode">
        <path
          d="M104.58 109.98h8.96v12.29h-8.96zM125 126.38c-1.26 0-2.27 1.06-2.27 2.51s1 2.46 2.27 2.45c1.26 0 2.27-1.03 2.27-2.49s-1-2.49-2.27-2.48Z"
          className="lucky-for-life_svg__cls-11"
        />
        <path
          d="M200.1 97.53c-3.39-1.47-6.87-2.85-10.34-4.11l-1.53-.56-4.64 4.04c-.68-1.84-1.37-3.68-2.05-5.52l-.32-.85-.86-.26c-1.47-.45-2.98-.89-4.52-1.32l-3.07-.83-.36-.09c-.46-.12-.91-.23-1.36-.34 0 0-1.13-.28-1.47-.36l-3.54-.86v.05c-1.61-.36-3.21-.69-4.78-.99l-1.08-.21-.69.85c-1.87 2.31-3.74 4.66-5.62 7.02v-8.95l-1.57-.22c-3.57-.51-7.2-.93-10.78-1.22l-1.98-.17-1.12 4.39c-3.02-3.44-7.53-5.36-12.86-5.36-6.59 0-12.39 3.38-15.78 8.48v-.84l-2.25-6.28-2.02.22c-3.57.39-7.16.89-10.7 1.48l-1.53.26v18.94c0 1.34-.21 2.3-.5 2.99V92.28l-4.58-6.34-2.22.48c-3.53.77-7.07 1.65-10.54 2.61l-1.34.37v18.11c0 1.89.21 3.58.59 5.1l-.45.13c-.87.25-1.75.51-2.63.77V99l-7.48-6.45-2.45.89c-3.44 1.25-6.89 2.63-10.24 4.08l-1.1.48v35.35l9.15 7.15 2.25-1.12c6.37-3.19 12.99-5.93 19.67-8.14l1.16-.38v-6.89s.02.03.03.04c.02.03.04.05.06.07.02.03.04.05.06.07s.04.05.06.07c.02.03.04.05.06.07.02.03.04.05.06.07.02.03.04.05.06.07.02.03.04.05.06.07.02.03.04.05.06.07.02.03.04.05.06.07.03.03.05.07.08.09.04.05.09.1.13.15.03.03.05.06.08.09 1.84 2.23 4.49 3.41 7.87 3.41 1.24 0 2.59-.17 4.01-.48 3.72-.81 6.79-2.47 9.14-4.82v6.41l2.05 4.49V138l.19.53c-.17.02-.34.03-.5.05l-1.63.17v23.69h-.01v-.08h-.03v-.07h-.03v-.07h-.03v-.07l-2.06.26c-2.19.28-4.39.6-6.58.95v-15.39l-4.17-7.28-2.18.43c-3.53.7-7.1 1.51-10.62 2.43l-1.37.36v35.14l5.87 7.93 2.01-.6c6.66-1.99 13.48-3.51 20.3-4.51l1.41-.21.08-.03 1.78-.21c3.1-.38 6.23-.65 9.31-.82l1.53-.08.43-.02 1.65-.05c1.32-.04 2.65-.06 3.97-.06 1.78 0 3.59.03 5.37.11l1.66.07.91-7.83h-.03.03v-3.03c2.71.15 5.42.38 8.11.69l1.77.21.29.03v10.93l1.42.2c6.98.99 13.97 2.51 20.77 4.54l2.01.6 5.75-7.93v-11.76l-1.37-.35c-.09-.02-.17-.04-.26-.07v-.09h.05v-9.11l1.58-2v-11.76l-1.37-.35c-7.89-2.04-16-3.57-24.09-4.55l-1.21-.15-.19-.02-.65-.08-.79-.07c-1.72-.19-3.44-.34-5.17-.48v-.05h.02v-.07h.02v-.07h.02v-.07h.02v-.07h.02v-.07h.02v-.06h.01l1.42-3.35v-2.97l2.14.03 3.93-5.58c.31.05.38.08.69.13l1.84.3 2.28-4.75c.73 1.65 1.46 3.29 2.18 4.9l.36.81.77.17c3.47.77 6.97 1.68 10.37 2.71l3.52 1.06 1.09.41 1.14.4c2.98 1.04 5.99 2.2 8.93 3.43l2.16.91 7.84-7.08V115.9c3.2-5.21 6.46-10.49 9.72-15.7l1.12-1.8-1.95-.85h-.01Zm-75.19 7.89c-1.01 0-1.69-.34-2.2-1.11-.1-.15-.19-.31-.27-.49.34-2.3 1.24-3.47 2.69-3.47 1.07 0 2.04.5 3.2 2.84-1.18 1.82-2.23 2.22-3.41 2.23Zm7.79-2.7c1.75-1.28 3.5-2.55 5.24-3.77v7.54c-1.75-1.28-3.49-2.54-5.24-3.77"
          className="lucky-for-life_svg__cls-11"
        />
        <path
          d="M62.88 95.16c-3.41 1.24-6.79 2.59-10.14 4.04v31.36c7.39-3.2 14.93-5.89 22.58-8.08v-7.98c-4.18 1.2-8.34 2.55-12.44 4.04zM95.69 103.9c0 4.04-1.65 6.16-4.41 6.69-2.71.52-4.34-.96-4.34-5V88.2c-3.5.76-6.98 1.62-10.43 2.59v16.72c0 9.72 5.5 13.44 14.77 11.63 9.33-1.77 15.01-7.64 15-17.37V85.05c-3.55.38-7.08.87-10.6 1.46v17.39ZM126.14 115.8c6.07 0 10.87-2.18 13.26-6.38-2.82-2.1-5.64-4.13-8.47-6.11-1.51 2.72-3.14 3.93-5.44 3.94-3.28.02-5.05-2.61-5.04-7.51 0-4.89 1.77-7.67 5.04-7.69 2.3-.01 3.92 1.26 5.44 4.05 2.82-1.83 5.64-3.6 8.47-5.3-2.39-4.54-7.19-7.31-13.26-7.3-9.61 0-17.07 7.76-17.07 16.96s7.47 15.35 17.07 15.35ZM189.7 95.13c-1.55 3.09-3.12 6.21-4.69 9.34-1.53-4.17-3.08-8.32-4.62-12.45-2.49-.76-5-1.46-7.52-2.12l-.36-.09c-.5-.13-.99-.25-1.5-.38-.44-.11-.87-.22-1.3-.32l-.34-.09q-3.93-.945-7.89-1.71c-2.94 3.65-5.9 7.36-8.86 11.15V85.82c-3.55-.51-7.1-.91-10.67-1.22v31.36c3.57.3 7.12.71 10.67 1.22v-7.75c.76-.97 1.52-1.93 2.28-2.89 2.08 3.98 4.17 8 6.24 12.06 4 .76 7.97 1.66 11.91 2.69-3.49-6.64-6.99-13.18-10.52-19.61 2.77-3.23 5.53-6.39 8.28-9.49 2.96 6.51 5.91 13.09 8.85 19.75v11.21c3.45 1.03 6.87 2.17 10.26 3.41v-11.21c3.36-5.48 6.69-10.88 10-16.16q-5.07-2.19-10.23-4.08v.02ZM113.37 121.21c0-.83.35-1.22.88-1.26.65-.04 1.38.48 1.83 1.26 1.16-.81 2.32-1.62 3.47-2.41-.83-1.65-2.41-2.6-5-2.43-2.97.19-5.67 2.68-5.67 6.36v.65c-.69.07-1.37.13-2.05.21v3.83l2.05-.21v8.75c1.7-.16 3.41-.3 5.11-.41v-8.75c.67-.05 1.36-.09 2.03-.12.19-.01.37-.03.56-.03v-3.83c-.93.05-1.87.11-2.79.17-.26-.58-.41-1.26-.41-1.77ZM125 122.27c-2.79.02-5.29 1.53-6.6 3.62v.03c-.48.77-.79 1.62-.9 2.5-.03.21-.04.42-.04.63 0 3.55 3.47 6.39 7.53 6.36 3.48-.03 6.52-2.16 7.32-4.99.13-.48.21-.97.21-1.48s-.08-1.01-.21-1.49c-.8-2.89-3.84-5.21-7.32-5.18Zm0 9.06c-1.26 0-2.27-1-2.27-2.45s1-2.51 2.27-2.51c1.26 0 2.27 1.03 2.27 2.48s-1 2.48-2.27 2.49ZM142.68 122.99c-1.35-.12-2.59.42-3.41 2.13v-2.4c-.82.17-1.56.18-3.35.08l-1.77-.09v4.47c.14.57.21 1.16.21 1.75 0-.58-.07-1.16-.21-1.73v8.08c1.71.07 3.41.17 5.12.28v-6c0-1.57.82-2.54 1.97-2.45.62.05 1.12.38 1.61 1.16 1.12-.92 2.23-1.83 3.35-2.73-.79-1.57-2.02-2.44-3.52-2.57ZM90.38 142.88c-3.53.69-7.03 1.5-10.52 2.4v31.36c7.69-1.99 15.48-3.49 23.32-4.47v-7.98c-4.29.54-8.55 1.23-12.8 2.07zM106.93 171.74c3.56-.38 7.13-.65 10.7-.81v-31.36c-3.57.17-7.14.44-10.7.81zM121.78 139.42v31.36c3.57-.09 7.15-.07 10.72.05v-10.74c4.09.14 8.19.41 12.27.81v-7.98c-4.08-.41-8.18-.68-12.27-.81v-4.66c4.49.15 8.97.46 13.44.94v-7.98c-8.03-.85-16.1-1.18-24.17-.99ZM148.76 172.08c8.02.98 15.99 2.48 23.86 4.51v-7.98c-4.38-1.13-8.79-2.1-13.22-2.9v-3.85c3.9.71 7.79 1.54 11.65 2.5v-7.98c-3.86-.96-7.75-1.79-11.65-2.5v-3.57c4.43.8 8.84 1.77 13.22 2.9v-7.98c-7.87-2.03-15.84-3.53-23.86-4.51z"
          className="lucky-for-life_svg__cls-65"
        />
      </g>
    </svg>
  );
};
export default SvgLuckyForLife;
